import classnames from "@src/utils/classnames"
import React from "react"
import CardButton from "../button"
import * as styles from "./originalCard.module.scss"

const OriginalCard = ({
  type,
  id,
  className,
  thumb,
  title,
  category,
  userThumb,
  userName,
  date,
  ...resProps
}) => {
  return (
    <CardButton
      {...resProps}
      className={classnames(styles.originalCard, className)}
      appNavTo={`https://www.gcores.com/${type}/${id}`}
    >
      <div
        className={styles.thumb}
        style={{ backgroundImage: `url(${thumb})` }}
      />
      <div className={styles.content}>
        <p className={styles.category}>{category}</p>
        <h3>{title}</h3>
        <div className={styles.btm}>
          <img className={styles.userThumb} src={userThumb} alt={title} />
          <p>
            <span>{userName}</span>
            <span>{date}</span>
          </p>
        </div>
      </div>
    </CardButton>
  )
}

export default OriginalCard
